import { useTheme } from "@mui/material";

const brand = {
  fb: "#1877F2",
  wa: "#25D366",
  waDark: "#1EBE57",
  success: "#16A34A",
  warning: "#F59E0B",
  danger: "#D32F2F",
};

const light = {
  ...brand,
  ink: "#14171F",
  inkMuted: "#5B6472",
  inkFaint: "#8A93A3",
  border: "#E4E7EC",
  surface: "#FFFFFF",
  page: "#F8F9FB",
  waLight: "#E8FDF0",
  successBg: "#EAF8EF",
  warningBg: "#FEF9E7",
  soft: "rgba(20,23,31,0.06)",
  softFaint: "rgba(20,23,31,0.04)",
  hoverTint: "rgba(20,23,31,0.03)",
};

const dark = {
  ...brand,
  ink: "#E7EAF0",
  inkMuted: "#A4ACBB",
  inkFaint: "#7F8897",
  border: "#2B313C",
  surface: "#1C212B",
  page: "#12161F",
  waLight: "#152E22",
  successBg: "rgba(22,163,74,0.16)",
  warningBg: "rgba(245,158,11,0.14)",
  soft: "rgba(255,255,255,0.07)",
  softFaint: "rgba(255,255,255,0.045)",
  hoverTint: "rgba(255,255,255,0.04)",
};

// Components read the palette through this hook so they follow dark mode.
export const useTokens = () => {
  const theme = useTheme();
  return theme.palette.mode === "dark" ? dark : light;
};
